/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        container: {
            position: 'relative',
            contentVisibility: 'auto',
            containIntrinsicSize: '0 400px'
        },
        favIcon: {
            position: 'absolute',
            variant: 'unstyled',
            top: 2,
            right: 2,
            zIndex: 2
        },
        imageWrapper: {
            position: 'relative',
            marginBottom: 2,
            overflow: 'hidden'
        },
        image: {
            ratio: 19 / 28,
            paddingBottom: 2,
            width: '100%',
            transition: 'opacity 0.3s ease-in-out'
        },
        responsiveMediaBlock: {
            paddingBottom: {base: 2, lg: 0},
        },
        hoveredImageContainer: {
            position: ['relative', 'relative', 'relative', 'absolute', 'absolute'],
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: 1,
            opacity: [1, 1, 0, 0, 0],
            transition: 'opacity 0.3s ease-in-out'
        },
        link: {
            display: 'block',
            _hover: {
                textDecoration: 'none'
            }
        },
        price: {},
        title: {
            fontWeight: 500,
            fontSize: ['12px', '14px'],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        rating: {},
        variations: {},
        badgeGroup: {
            position: 'absolute',
            ...(props?.isDesktop ? {top: 1} : {bottom: 2}),
            left: props?.isDesktop ? 1 : 2,
            zIndex: 5,
            alignItems: 'start'
        },
        badge: {
            padding: '6px 8px',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            background: 'whiteAlpha.750',
            backdropFilter: 'blur(5px)',
            color: 'black',
            textAlign: 'center',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            textTransform: 'uppercase',
            borderRadius: 0
        },
        toolTip: {
            background: 'white',
            padding: '4px',
            maxWidth: '200px',
            borderRadius: '2px',
            fontWeight: 400
        },
        toolTipIcon: {
            width: '12px',
            height: '12px',
            marginLeft: 1,
            marginTop: 1,
            color: 'black'
        },
        productTileLabel: {
            fontSize: 12,
            textTransform: 'uppercase',
            fontWeight: 500,
            pointerEvents: 'none'
        }
    }),
    variants: {
        VerticalList: {
            link: {
                boxSizing: 'border-box',
                overflow: 'auto',
                display: 'block',
            },
            imageWrapper: {
                float: 'left',
                width: {base: '95px', lg: '225px'},
                boxSizing: 'border-box',
                marginBottom: 0
            },
            bodyText: {
                marginLeft: {base: '95px', lg: '225px'},
                marginTop: '0',
                marginBottom: '0',
                padding: {base: '0 0 0 8px'},
                boxSizing: 'border-box',
                clear: 'none',
            },
            title: {
                textOverflow: 'unset',
                whiteSpace: 'unset'
            }
        },
        ModalVerticalList: {
            imageWrapper: {
                float: 'left',
                width: {base: '95px', lg: '95px'},
                boxSizing: 'border-box',
                marginBottom: 0
            },
            bodyText: {
                marginLeft: {base: '95px', lg: '95px'},
                marginTop: '0',
                marginBottom: '0',
                padding: {base: '0 0 0 8px'},
                boxSizing: 'border-box',
                clear: 'none'
            },
            title: {
                textOverflow: 'unset',
                whiteSpace: 'unset'
            }
        }
    },
    parts: [
        'container',
        'favIcon',
        'imageWrapper',
        'bodyText',
        'image',
        'hoveredImageContainer',
        'link',
        'price',
        'title',
        'rating',
        'variations',
        'badgeGroup',
        'badge',
        'toolTip',
        'toolTipIcon',
        'productTileLabel'
    ]
}
